import environment from '../util/environment'

if (environment.isTest) {
  // Disable smooth scrolling to avoid flaky tests due to scroll animations
  up.element.affix(document.head, 'style[up-asset="false"]', {
    text: '* { scroll-behavior: auto !important }',
  })
}
